import { Component } from 'react';
import $ from 'jquery';

export default function CloseOutsideBorderComponent(MyComponent, onClickHandler, closingClass) {
  class HocComponent extends Component {
    constructor(props) {
      super(props);

      this.closeBinding = '';
    }

    componentDidMount() {
      if (this.closeBinding) {
        this.closeBinding.unbind();
      }

      this.closeBinding = $('body').on('click', (e) => {
        const $labelToBeClosed = $(closingClass);
        if ($labelToBeClosed.length > 0) {
          const $modalBottom = $labelToBeClosed.offset().top + $labelToBeClosed.outerHeight();
          /* Add 56 to exclude 56 px on top of composed component */
          const $modalTop = $labelToBeClosed.offset().top - 56;
          const $modalLeft = $labelToBeClosed.offset().left;
          const $modalRight = $labelToBeClosed.offset().left + $labelToBeClosed.outerWidth();

          /* IE11 fix */
          if (e.pageY < 0) return;

          if (e.pageY > $modalBottom || e.pageY < $modalTop || e.pageX > $modalRight || e.pageX < $modalLeft) {
            onClickHandler();
          }
        }
      });
    }

    render() {
      return (
        <MyComponent {...this.props} />
      );
    }
  }

  return HocComponent;
}

